import { Box } from '@material-ui/core'
import styled from 'styled-components'

export const StyledTakeActionIconWrapper = styled(Box)`
  && svg ellipse,
  && svg circle,
  && svg path {
    fill: ${props => props.theme.colors.accent1};
  }
`

//@ts-ignore
export const StyledCalendarWrapper = styled(StyledTakeActionIconWrapper)`
  && svg ellipse,
  && svg circle,
  && svg path {
    fill: ${props => props.theme.colors.accent};
  }
`

//@ts-ignore
export const StyledClockWrapper = styled(StyledCalendarWrapper)``
